import React, { useEffect, useState, /*useReducer,*/ useContext } from "react";
import { makeStyles, Grid, Typography, Collapse, RootRef, useMediaQuery, useTheme } from "@material-ui/core";
//import { useHistory } from 'react-router-dom'
//import randomMC from 'random-material-color'
import { AuthContext } from "../context";
import { TextField, /*ProductCard, LabCard ,*/ Paper, Loader, AssignCard, Button, PopUp } from "../components";
import { SearchIcon } from "../icons";
import { doctorServices } from "../services";
import { modals } from "../constants";
import { useScroll, useResize } from "../hooks";

export default function HistoryScreen(props) {
  //const { state } = useContext(AuthContext);
  const [buttonActive, setButtonActive] = useState(0);
  const { paperGrow, domRef, onScroll } = useScroll(100);
  const [imageLoaded, setImageLoaded] = useState(false);
  const { collapseH } = useResize(imageLoaded);
  const classes = useStyles({ buttonActive, paperGrow, collapseH, ...props })();
  const [query, setQuery] = useState("");
  const [orders, setOrders] = useState([]);
  const [assigments, setAssigments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [forRequest, setForRequest] = useState(false);
  const [changeSize, setChangeSize] = useState(false);
  const { authState, signOut } = useContext(AuthContext);
  const [filteredAssigments, setFilteredAssigments] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [filterA, setFilterA] = useState(false);
  const [filterO, setFilterO] = useState(false);
  const [indexOpen, setIndexOpen] = useState(null);
  //const history = useHistory();
  const [modal, setModal] = useState(false);
  const [statusModal, setStatusModal] = useState(null);
  const [isOrder, setIsOrder] = useState(false);
  //const [modalName, setModalName] = useState('')
  //const [labs, setLabs] = useState([])
  const matchesDesktop = useMediaQuery(useTheme().breakpoints.up("md"));

  useEffect(() => {
    async function init() {
      try {
        setLoading(true);
        const { status, response } = await doctorServices.getPatiensAssignProducts({ token: authState.token, _id: authState.user.doctor._id });
        setLoading(false);
        if (status === 200) {
          setAssigments(response.assigments);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        setLoading(false);
        console.log("Error", e);
      }
    }
    init();
  }, [authState, signOut]);

  const onClickButton = async (button, showOrders) => {
    setButtonActive(button);
    if (showOrders !== forRequest) {
      try {
        setLoading(true);
        const { status, response } = await doctorServices.getOrdersList({ token: authState.token, _id: authState.user.doctor._id });
        setLoading(false);
        if (status === 200) {
          setOrders(response.orders);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        setLoading(false);
        console.log("Error", e);
      }
    }
    setForRequest(showOrders);
  };

  const filterList = (value) => {
    if (value === "") {
      setFilterA(false);
      setFilterO(false);
    }
    setQuery(value);
    if (!buttonActive) {
      setFilteredAssigments(
        assigments.filter(
          (assigment) =>
            assigment.firstName.toLowerCase().includes(value.toLowerCase()) ||
            assigment.lastName.toLowerCase().includes(value.toLowerCase()) ||
            assigment.rut.toLowerCase().includes(value.toLowerCase())
        )
      );
      setFilterA(true);
    } else {
      setFilteredOrders(orders.filter((order) => order.laboratory.name.toLowerCase().includes(value.toLowerCase()) || order.product.name.toLowerCase().includes(value.toLowerCase())));
      setFilterO(true);
    }
  };

  return (
    <Grid container>
      <PopUp modalName={modals[8]} open={modal} status={statusModal} setModal={() => setModal(!modal)} isOrder={isOrder} />
      {loading && <Loader loading={true} />}
      <Grid className={classes.container} container>
        <Collapse in={!matchesDesktop ? !paperGrow : true} timeout={500} style={{ width: "100%" }} id={"collapseId"}>
          <Grid className={classes.containerImage} container>
            <Grid item md={3} xs={6}>
              <img src="../../assets/historial.svg" alt="" onLoad={() => setImageLoaded(true)} />
            </Grid>
            <Grid md={9} className={classes.desktopOptions} container justify="flex-start" alignItems="center" item>
              <Grid item md={12} lg={12}>
                <Typography component="h1" variant="h1">
                  Historial
                </Typography>
              </Grid>
              <Grid item md={12} style={{ margin: "20px 0 0 0" }}>
                <Grid container justify="space-between" alignItems="center">
                  <Grid item md={8} style={{ position: "relative" }}>
                    <TextField
                      type={"text"}
                      name={"query"}
                      value={query}
                      placeholder="¿Qué estás buscando?"
                      fontWeight="bold"
                      style={{ justifyContent: "flex-end" }}
                      showIcon
                      iconComponent={() => <SearchIcon />}
                      onClickIcon={() => {}}
                      onChange={(e) => filterList(e.target.value)}
                    />
                  </Grid>
                  <Grid item md={6} container>
                    <Grid container justify="space-between" spacing={2} className={classes.buttonGroup}>
                      <Grid item xs={6}>
                        <Button fullWidth onClick={() => onClickButton(0, false)}>
                          ASIGNACIONES
                        </Button>
                      </Grid>
                      <Grid item xs={6}>
                        <Button fullWidth onClick={() => onClickButton(1, true)}>
                          SOLICITUDES
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Collapse>
        <Paper className={classes.paperClass}>
          <Grid container className={classes.titleHistory}>
            {!changeSize && (
              <Grid container justify="flex-start" alignItems="center" item md={4} xs={10}>
                <Typography component="h1" variant="h1" align="center">
                  Historial de actividad
                </Typography>
              </Grid>
            )}
            <Grid container justify="flex-end" item md={8} xs={changeSize ? 12 : 2}>
              <TextField
                type={"text"}
                name={"query"}
                value={query}
                style={{ width: 50, justifyContent: !changeSize ? "center" : "flex-end" }}
                placeholder={changeSize ? "¿Qué estás buscando?" : ""}
                fontWeight="bold"
                showIcon
                iconComponent={() => <SearchIcon onClick={!changeSize ? () => setChangeSize(!changeSize) : () => {}} />}
                onClickIcon={() => {}}
                onChange={(e) => filterList(e.target.value)}
              />
            </Grid>
            <Grid container justify="space-between" spacing={2} className={classes.buttonGroup}>
              <Grid item xs={6}>
                <Button fullWidth onClick={() => onClickButton(0, false)}>
                  ASIGNACIONES
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button fullWidth onClick={() => onClickButton(1, true)}>
                  SOLICITUDES
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <RootRef rootRef={domRef}>
            <Grid container spacing={2} className={classes.scrollList} onScroll={onScroll}>
              {filterA && !filteredAssigments.length && (
                <Grid item xs={12} md={12} className={classes.emptyKit} container justify="center" alignItems="center" direction="column">
                  <img src="../assets/danger-circle.svg" alt="" />
                  <Typography align="center">
                    Paciente <br /> no encontrado
                  </Typography>
                  <Typography align="center">
                    Por favor intente <br /> nuevamente
                  </Typography>
                </Grid>
              )}
              {!forRequest &&
                !filterA &&
                assigments.map((assigment, index) => (
                  <Grid item md={12} xs={12} key={index}>
                    <AssignCard
                      assigment={assigment}
                      onClickStatus={() => {
                        setStatusModal(assigment.status);
                        setIsOrder(false);
                        setModal(true);
                      }}
                      open={indexOpen}
                      openCard={() => setIndexOpen(indexOpen === index ? null : index)}
                      index={index}
                    />
                  </Grid>
                ))}
              {!forRequest &&
                filterA &&
                filteredAssigments.map((assigment, index) => (
                  <Grid item md={12} xs={12} key={index}>
                    <AssignCard
                      assigment={assigment}
                      onClickStatus={() => {
                        setStatusModal(assigment.status);
                        setIsOrder(false);
                        setModal(true);
                      }}
                      open={indexOpen}
                      openCard={() => setIndexOpen(indexOpen === index ? null : index)}
                      index={index}
                    />
                  </Grid>
                ))}
              {filterO && !filteredOrders.length && (
                <Grid item xs={12} md={12} className={classes.emptyKit} container justify="center" alignItems="center" direction="column">
                  <img src="../assets/danger-circle.svg" alt="" />
                  <Typography align="center">
                    Orden <br /> no encontrada
                  </Typography>
                  <Typography align="center">
                    Por favor intente <br /> nuevamente
                  </Typography>
                </Grid>
              )}
              {forRequest &&
                !filterO &&
                orders.map((order, index) => (
                  <Grid item md={12} xs={12} key={index}>
                    <AssignCard
                      order={order}
                      onClickStatus={() => {
                        setStatusModal(order.status);
                        setIsOrder(true);
                        setModal(true);
                      }}
                      isOrder
                      open={indexOpen}
                      openCard={() => setIndexOpen(indexOpen === index ? null : index)}
                      index={index}
                    />
                  </Grid>
                ))}
              {forRequest &&
                filterO &&
                filteredOrders.map((order, index) => (
                  <Grid item md={12} xs={12} key={index}>
                    <AssignCard
                      onClickStatus={() => {
                        setStatusModal(order.status);
                        setIsOrder(true);
                        setModal(true);
                      }}
                      order={order}
                      isOrder
                      open={indexOpen}
                      openCard={() => setIndexOpen(indexOpen === index ? null : index)}
                      index={index}
                    />
                  </Grid>
                ))}
            </Grid>
          </RootRef>
        </Paper>
      </Grid>
      {false && (
        <Grid container className={classes.containerBtn}>
          <Button onClick={() => {}} fullWidth className={classes.btn}>
            SOLICITAR MUESTRAS
          </Button>
        </Grid>
      )}
    </Grid>
  );
}

const useStyles = ({ buttonActive, paperGrow, collapseH, ...props }) =>
  makeStyles((theme) => ({
    container: {
      display: "block",
      height: "100%",
      [theme.breakpoints.up("md")]: {
        padding: "50px 50px 0 50px",
      },
    },
    containerBtn: {
      position: "fixed",
      bottom: "calc(90px + env(safe-area-inset-bottom, 0px))",
      padding: "0 12px",
      zIndex: 3,
      "& button": {
        backgroundColor: theme.palette.secondary.main,
        color: "#FFF",
        height: 41,
        borderRadius: 20.5,
        fontSize: "1.125rem",
        lineHeight: "1.375rem",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: theme.palette.secondary.main,
        },
      },
    },
    buttonGroup: {
      margin: "21px 0 0 0",
      width: "100%",
      "& div:nth-child(1)": {
        paddingLeft: 0,
        "& button": {
          backgroundColor: buttonActive ? "#FFF" : theme.palette.secondary.main,
          fontWeight: "bold",
          fontSize: "0.875rem",
          lineHeight: "1.063rem",
          height: 37,
          borderRadius: 25,
          color: buttonActive ? theme.palette.secondary.main : "#FFF",
          border: buttonActive ? `1px solid ${theme.palette.secondary.main}` : "unset",
          boxSizing: "border-box",
          "&:hover": {
            backgroundColor: buttonActive ? "#FFF" : theme.palette.secondary.main,
          },
        },
      },
      "& div:nth-child(2)": {
        paddingRight: 0,
        " & button": {
          backgroundColor: buttonActive ? theme.palette.secondary.main : "#FFF",
          color: buttonActive ? "#FFF" : theme.palette.secondary.main,
          fontWeight: "bold",
          fontSize: "0.875rem",
          lineHeight: "1.063rem",
          height: 37,
          borderRadius: 25,
          border: `1px solid ${theme.palette.secondary.main}`,
          boxSizing: "border-box",
          "&:hover": {
            backgroundColor: buttonActive ? theme.palette.secondary.main : "#FFF",
          },
        },
      },
    },
    paperClass: {
      height: paperGrow ? "100%" : "calc(100% - 150px)",
      [theme.breakpoints.up("md")]: {
        height: `calc(100% - ${collapseH}px)`,
      },
    },
    desktopOptions: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    containerImage: {
      justifyContent: "center",
      [theme.breakpoints.up("md")]: {
        justifyContent: "flex-start",
        margin: "0 0 50px 0",
      },
      "& > div:nth-child(1)": {
        padding: "10px 0",
        [theme.breakpoints.up("md")]: {
          padding: 0,
        },
        "& img": {
          [theme.breakpoints.up("md")]: {
            width: "100%",
          },
        },
      },
      "& > div:nth-child(2)": {
        [theme.breakpoints.up("md")]: {
          padding: "0 0 0 40px",
        },
      },
    },
    titleHistory: {
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    titleHistoryDesktop: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    scrollList: {
      height: "calc(100% - 140px)",
      [theme.breakpoints.up("md")]: {
        height: "98%",
      },
      [theme.breakpoints.down("sm")]: {
        "&::-webkit-scrollbar": {
          width: "1px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0,0,0, .1)",
        },
      },
      overflowY: "scroll",
      display: "block",
      paddingTop: 0,
      width: "100%",
      margin: 0,
      "&::-webkit-scrollbar": {
        width: "4px",
        height: "8px",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.secondary.main,
        borderRadius: "10px",
      },
    },
  }));
